import { Button, SafeArea } from "antd-mobile";
import FailIcon from "../assets/fail.svg";
import style from "./index.module.scss";

const ErrorPage = () => {
  const closePage = () => {
    window.open("", "_self")?.close();
    window.history.back();
  };

  return (
    <div className={style.errorPage}>
      <img alt="" src={FailIcon} className={style.resultIcon} />
      <div className={style.resultTip}>链接超时已失效，请联系客服</div>
      <div className={style.footer}>
        <Button block size="large" onClick={closePage}>
          确定
        </Button>
        <SafeArea position="bottom" />
      </div>
    </div>
  );
};

export default ErrorPage;
